import { render, staticRenderFns } from "./ListCourses.vue?vue&type=template&id=53c81583&"
import script from "./ListCourses.vue?vue&type=script&lang=js&"
export * from "./ListCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports